import React from 'react';
import { TimelineItemAllColours } from '../../';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const LineMiddleItem: React.FC<Props> = ({ item, isSimple, isExpanded }) => (
  <TimelineItemAllColours
    item={item}
    isSimple={isSimple}
    isExpanded={isExpanded}
  />
);

export default LineMiddleItem;
